import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PageRootWrapper from '../../components/common/PageRoot/PageRootWrapper';
import ImpressionStatsContainer from '../../components/ImpressionStats/ImpressionStatsContainer';

const ImpressionStats = ({ location }) => (
    <PageRootWrapper location={location}>
        <ImpressionStatsContainer />
    </PageRootWrapper>
);

ImpressionStats.propTypes = {
    location: ReactRouterPropTypes.location.isRequired,
};

export default ImpressionStats;
